import { getAssessmentPrograms } from "./network";

export const generateReportLogic = async ({
  jwt,
  studentId,

  handleMspLogo,
}: {
  jwt: string;
  studentId: "string";
  handleMspLogo: (e: any) => void;
}) => {
  // Fetch programs
  const resPrograms = await getAssessmentPrograms({
    jwt: jwt,
    student_id: studentId,
  });

  const programs = await resPrograms.results;
  const vendorUrlObject = await programs?.reduce((acc: any, item: any) => {
    if (item?.assessment_id && item?.vendorurl) {
      acc[item.assessment_id] = item.vendorurl;
    }
    return acc;
  }, {});

  await handleMspLogo(vendorUrlObject);
};
